import { mountStarfield } from "./starfield.js";

/** @type {Partial<import("./starfield.js").StarfieldOptions>} */
const options = {
  enabled: true,
  seed: 184215,
  density: 1.89,
  motionSource: "pointer",
  motionMode: "warp",
  driftSpeed: 0.35,
  driftAngle: -25,
  zoomSpeed: 0.18,
  warpSpeed: 0.22,
  pointerInfluence: 0.36,
  pointerSmoothing: 0.08,
  twinkle: 0.85,
  streakStrength: 0.12,
};
const canvas = document.querySelector("#orion-sector");
const allowAnimations = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;

if (allowAnimations && canvas instanceof HTMLCanvasElement) {
  mountStarfield(canvas, options);
}
